import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericFeatureList from '../shared/generic-feature-list';
import { SpaMarketAPI } from '../../services/feature-api';
import { getFeatureConfig } from '../../config/featureDisplayConfig';

const config = getFeatureConfig('spa-market');

const fetchData = async (accessToken, filters) => {
  const result = await SpaMarketAPI.getList(accessToken, filters);
  const items = result.success ? (result.data?.rows || result.data?.items || []) : [];
  const list = Array.isArray(items) ? items : [];
  return {
    items: list,
    summary: {
      total: list.length,
      approved: list.filter((r) => r.companyApproved === 'approved').length,
      pending: list.filter((r) => r.companyApproved === 'pending').length,
    },
  };
};

const SpaMarketList = (props) => {
  const navigate = useNavigate();
  return (
    <GenericFeatureList
      title={config.listConfig.title}
      fetchData={fetchData}
      columns={config.listConfig.columns}
      summaryFields={config.listConfig.summaryFields}
      displayMode={config.listConfig.displayMode}
      createPath={config.createPath}
      notice={config.notice}
      guideUrl={config.guideUrl}
      accentColor={config.color}
      onItemClick={(item) => navigate(config.editPath, { state: { editData: item } })}
      {...props}
    />
  );
};

export default SpaMarketList;
